import api from '@stencil/megatron/src/api';
import Megatron from '@stencil/megatron';

import {getFlyerDetails, getMAPIBaseUrl} from '@stencil/hotels-utils/src/common-utils';
import {getDeviceDetail, getSearchCriteria, getRequestDetails} from './apiUtils';
import {SEARCH_ROOM_BASE_URL} from './apiUrls';
import {getExperimentData} from '@stencil/hotels-utils/src/get-experiment-data';

export const prepareSearchRoomsRequest = async requestObj => {
  const {
    urlParams,
    pokus,
    selectedCurrency,
    requiredFlags,
    travellerEmailId,
    flavour,
    filterCriteria,
    cmpValue = '',
    sessionIdValue = '',
    deviceIdVal = '',
  } = requestObj;
  const isDesktop = flavour === 'desktop';

  const requestDetails = getRequestDetails({urlParams, cmpValue, sessionIdValue, deviceIdVal});

  const flyerDetails = await getFlyerDetails();
  if (flyerDetails) {
    requestDetails['flyerInfo'] = flyerDetails;
  }

  const additionalData = pokus?.select_room_page
    ? pokus?.srskippwa
      ? {SRV2: 'T', SRSKIP: 'T'}
      : {SRV2: 'T'}
    : {};

  return {
    deviceDetails: getDeviceDetail(isDesktop),
    searchCriteria: getSearchCriteria({urlParams, selectedCurrency, travellerEmailId}),
    requestDetails: requestDetails,
    filterCriteria: filterCriteria || [],
    featureFlags: {
      addOnRequired: !!requiredFlags.addOnRequired,
      applyAbsorption: !!requiredFlags.applyAbsorption,
      bestCoupon: !!requiredFlags.bestCoupon,
      freeCancellationAvail: !!requiredFlags.freeCancellationAvail,
      responseFilterFlags: !!requiredFlags.responseFilterFlags,
      soldOutInfoReq: !!requiredFlags.soldOutInfoReq,
      walletRequired: !!requiredFlags.walletRequired,
      detailPersuasionCardsRequired: !!requiredFlags.detailPersuasionCardsRequired,
      bestOffersLimit: 3,
      elitePackageEnabled: true,
    },
    expData: getExperimentData({pokus, additionalData: {...additionalData}}),
  };
};
export const fetchSearchRoomData = async (requestObj, client = 'DESKTOP') => {
  const searchRoomsRequestObj = await prepareSearchRoomsRequest(requestObj);
  return await api.post(
    getMAPIBaseUrl(),
    SEARCH_ROOM_BASE_URL.replace(':client', client),
    searchRoomsRequestObj,
    true,
  );
};
